import React, { useEffect, useRef, useState } from "react";
import { Tooltip } from "antd";
import "antd/es/tooltip/style/css";
import IconFont from "@meitu/xdesign-icon-font";
import styles from "./index.module.css";

interface TagSelectProps {
  list: any[];
  active: string;
  title?: string;
  config?: {
    label?: string;
    value?: string;
    desc?: string;
    icon?: string;
  };
  onTagSelect?: (tag: string) => void;
}

const TagSelect = (props: TagSelectProps) => {
  const {
    list,
    active,
    title,
    onTagSelect,
    config = {
      label: "label",
      value: "value",
      desc: "desc",
      icon: "icon",
    },
  } = props;
  const { label, value, desc, icon } = config;
  const wrapRef = useRef<HTMLDivElement>(null);
  const scrollRef = useRef<HTMLDivElement>(null); // 新增对滚动容器的引用
  const [showAction, setShowAction] = useState(false);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);

  const scrollStep = 200; // 定义滚动的步长

  useEffect(() => {
    const scrollRefCurrent = scrollRef.current;
    if (scrollRefCurrent) {
      setShowAction(
        scrollRefCurrent.scrollWidth > scrollRefCurrent.clientWidth
      );
      setShowRight(scrollRefCurrent.scrollWidth > scrollRefCurrent.clientWidth);
    }
  }, [list]);

  // 向左滚动
  const handleScrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft -= scrollStep;
      setTimeout(() => {
        const currentScrollLeft = scrollRef.current!.scrollLeft;
        // 判断是否已滚动到最左侧
        if (currentScrollLeft <= 63) {
          setShowLeft(false);
          setShowRight(true);
        } else {
          setShowLeft(true);
          setShowRight(true);
        }
      }, 500);
    }
  };

  // 向右滚动
  const handleScrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft += scrollStep;

      setTimeout(() => {
        const currentScrollLeft = scrollRef.current!.scrollLeft;
        const scrollWidth = scrollRef.current!.scrollWidth; // 总滚动宽度
        const clientWidth = scrollRef.current!.clientWidth; // 可视区域宽度
        console.log(currentScrollLeft, scrollWidth - clientWidth);
        // 判断是否已滚动到最右侧
        if (currentScrollLeft >= scrollWidth - clientWidth) {
          setShowRight(false);
          setShowLeft(true);
        } else {
          setShowRight(true);
          setShowLeft(true);
        }
      }, 500);
    }
  };

  const tagSelect = (item: any) => {
    onTagSelect?.(item[value!]);
  };
  const renderList = () => {
    return list.map((item) => {
      return item[desc!] ? (
        <Tooltip key={item[value!]} title={item[desc!]} placement="top">
          <div
            className={`${styles.tagSelectItem} ${
              active === item[value!] ? styles.active : ""
            }`}
            onClick={() => tagSelect(item)}
          >
            {item[icon!] && (
              <IconFont
                name={item[icon!]}
                fontSize={14}
                style={{
                  marginRight: 4,
                }}
              />
            )}
            <div>{item[label!]}</div>
          </div>
        </Tooltip>
      ) : (
        <div
          key={item[value!]}
          className={`${styles.tagSelectItem} ${
            active === item[value!] ? styles.active : ""
          }`}
          onClick={() => tagSelect(item)}
        >
          {item[icon!] && !item[icon!].includes("http") && (
            <IconFont
              name={item[icon!]}
              fontSize={14}
              style={{
                marginRight: 4,
              }}
            />
          )}

          {item[icon!] && item[icon!].includes("http") && (
            // eslint-disable-next-line @next/next/no-img-element
            <img className={styles.newIcon} src={item[icon!]} alt="图片" />
          )}
          <div>{item[label!]}</div>
        </div>
      );
    });
  };
  return (
    <div ref={wrapRef} className={styles.tagSelect}>
      {title && <div className={styles.tagSelectTitle}>{title}</div>}
      <div className={styles.tagListAction}>
        {showAction && showLeft && (
          <div
            className={`${styles.actionIcon} ${styles.actionLeft}`}
            onClick={handleScrollLeft}
            style={{
              left: title ? 68 : 0,
            }}
          >
            <IconFont name="ChevronLeftBlack" />
          </div>
        )}
        {showAction && showRight && (
          <div
            className={`${styles.actionIcon} ${styles.actionRight}`}
            onClick={handleScrollRight}
          >
            <IconFont name="ChevronRightBlack" />
          </div>
        )}
      </div>

      <div className={styles.tagSelectList}>
        <div className={styles.tagSelectScroll} ref={scrollRef}>
          {renderList()}
        </div>
      </div>
    </div>
  );
};

export default React.memo(TagSelect);
